import React from 'react';
import SectorPage from '../SectorPage/SectorPage';

const Hotellerie = () => {
  const sectorData = {
    title: "Hôtellerie",
    subtitle: "Accélérez votre prospection B2B",
    intro: "Les fournisseurs de solutions pour hôtels (PMS, conciergerie, gestion énergétique, restauration) doivent prospecter par typologie d'établissement. Mettre en avant la réduction des coûts d'exploitation, les avis clients ou les cas d'usage selon la saison est essentiel.",
    name: "Hôtellerie",
    titleContext: "du secteur de l'hôtellerie",
    responseContext: "du secteur de l'hôtellerie",
    expertContext: "du secteur de l'hôtellerie"
  };

  return <SectorPage sector={sectorData} />;
};

export default Hotellerie; 